/* eslint-disable no-console */
import { useCallback, useMemo } from 'react';
import { GatewayContextType } from '../context';

interface GatewayProps {
  gatewayUrl?: string;
  getAuthToken?: () => string;
}

export default function useGateway(props: GatewayProps): GatewayContextType {
  const { gatewayUrl, getAuthToken } = props;

  /**
   * Strips the bearer from the props.getAuthToken() response. This provides
   * a consistant experience no matter the function that is passed into the App
   * @returns The auth token, with the bearer stripped
   */
  const getAuthTokenWrapped = useCallback(() => {
    if (!getAuthToken) {
      return '';
    }

    var authToken = getAuthToken();
    if (authToken && authToken.startsWith('Bearer')) {
      authToken = authToken.slice(7);
    }

    return authToken;
  }, [getAuthToken]);

  const canUseGatewayApi = useMemo(() => {
    if (!gatewayUrl) {
      return false;
    }

    var token = getAuthTokenWrapped();
    if (!token) {
      return false;
    }

    return true;
  }, [gatewayUrl, getAuthTokenWrapped]);

  const gatewayUrlNullCheck = useMemo(() => {
    return gatewayUrl ? gatewayUrl : '';
  }, [gatewayUrl]);

  return { gatewayUrl: gatewayUrlNullCheck, getAuthToken: getAuthTokenWrapped, canUseGatewayApi };
}
